var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 22,
    viewBox: "0 0 35 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.1085 8.305C27.1248 3.56125 22.7414 0 17.4755 0C13.2947 0 9.66357 2.255 7.85524 5.555C3.50079 5.995 0.115601 9.50125 0.115601 13.75C0.115601 18.3012 4.00712 22 8.79557 22H27.6022C31.595 22 34.8355 18.92 34.8355 15.125C34.8355 11.495 31.8698 8.5525 28.1085 8.305ZM20.3689 12.375V17.875H14.5822V12.375H10.2422L17.4755 5.5L24.7088 12.375H20.3689Z",
    fill: "#508CC0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadImage);
export default __webpack_public_path__ + "static/media/upload-image.8298622f94c379f53a402c3158d6ca4d.svg";
export { ForwardRef as ReactComponent };